<template>
  <div class="global-advanced-portal-student" :class="{ dark }">
    <v-container
      class="config-form-content adminWeeducPortalStudentImage weeduc-admin-config weeduc-admin-portal-student-inner"
      data-aos="fade-left"
      data-aos-duration="1500"
      fluid
    >
      <div class="weeduc-admin-portal-student__intro" id="titleContainerPortalStudent">
        <h3 class="weeduc-admin-portal-student__title">{{ $t('admin.siteConfig.portalTitle') }}</h3>
        <p class="weeduc-admin-portal-student__lead">
          {{ $t('admin.siteConfig.portalLead') }}
        </p>
      </div>

      <v-card
        class="weeduc-admin-portal-student__surface weeduc-admin-portal-student__card"
        variant="outlined"
        rounded="lg"
        elevation="0"
      >
        <v-card-text class="weeduc-admin-portal-student__card-body pa-4 pa-sm-5">
          <div id="contentContainerPortalStudent" class="weeduc-admin-portal-student__layout">
            <div
              id="contentSelectContainerPortalStudent"
              class="weeduc-admin-portal-student__col weeduc-admin-portal-student__col--settings"
            >
              <h4 class="weeduc-admin-portal-student__card-heading labeld required">
                {{ $t('admin.siteConfig.portalSettings') }}
              </h4>

              <div class="weeduc-admin-portal-student__field">
                <v-select
                  v-model="showCertificate"
                  :items="optionsAtivoInativo"
                  item-title="text"
                  item-value="value"
                  :label="$t('admin.siteConfig.showCertificate')"
                  variant="outlined"
                  density="compact"
                  class="weeduc-admin-v-field"
                  :menu-props="adminSelectMenuProps"
                  hide-details="auto"
                />
                <small class="weeduc-admin-portal-student__field-hint">
                  {{ $t('admin.siteConfig.showCertificateHint') }}
                </small>
              </div>

              <div class="weeduc-admin-portal-student__field">
                <v-select
                  v-model="showInquiry"
                  :items="optionsAtivoInativo"
                  item-title="text"
                  item-value="value"
                  :label="$t('admin.siteConfig.showDoubts')"
                  variant="outlined"
                  density="compact"
                  class="weeduc-admin-v-field"
                  :menu-props="adminSelectMenuProps"
                  hide-details="auto"
                />
                <small class="weeduc-admin-portal-student__field-hint">
                  {{ $t('admin.siteConfig.showDoubtsHint') }}
                </small>
              </div>

              <div class="weeduc-admin-portal-student__field">
                <v-select
                  v-model="showForum"
                  :items="optionsAtivoInativo"
                  item-title="text"
                  item-value="value"
                  :label="$t('admin.siteConfig.showForum')"
                  variant="outlined"
                  density="compact"
                  class="weeduc-admin-v-field"
                  :menu-props="adminSelectMenuProps"
                  hide-details="auto"
                />
                <small class="weeduc-admin-portal-student__field-hint">
                  {{ $t('admin.siteConfig.showForumHint') }}
                </small>
              </div>
            </div>

            <div
              id="contentImageContainerPortalStudent"
              class="weeduc-admin-portal-student__col weeduc-admin-portal-student__col--media"
            >
              <label
                for="portalStudentImageSelect"
                class="labeld required weeduc-admin-portal-student__media-label"
              >
                {{ $t('admin.siteConfig.portalImage') }}
              </label>
              <div class="weeduc-admin-portal-student__upload-zone">
                <CustomFileInput
                  id="portalStudentImageSelect"
                  v-model="image"
                  :image-preview="imagePreview"
                  height="200"
                  :can-delete="false"
                  :info-text="$t('admin.siteConfig.portalImageHint')"
                  @update:modelValue="updateFilePath"
                />
              </div>
              <p class="helper-text weeduc-admin-portal-student__helper">
                {{ $t('admin.siteConfig.portalBannerSize') }}
              </p>
            </div>
          </div>
        </v-card-text>

        <v-card-actions
          id="buttonContainerPortalStudent"
          class="weeduc-admin-portal-student__card-footer weeduc-admin-site-form-actions flex-wrap"
        >
          <v-spacer />
          <v-btn
            color="primary"
            class="btn-content weeduc-admin-portal-student__save-btn"
            @click="salvarPortalAluno"
            :loading="loading"
            :disabled="loading"
            id="btnSavePortalStudent"
          >
            <span v-if="!loading">{{ $t('admin.siteConfig.savePublish') }}</span>
            <span v-else>{{ $t('common.loading') }}</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import apiAWS from '@/utils/storage/aws'
import apiWebsite from '@/utils/Weflix/content'
import { mapState } from 'vuex'
import CustomFileInput from '@/components/Form/CustomFileInput.vue'
import { toast } from 'vue3-toastify'

export default {
  name: 'PortalStudentImageUpload',
  components: {
    CustomFileInput,
  },
  data() {
    return {
      image: '',
      imagePreview: null,
      imageUpload: null,
      loading: false,
      dataWebsite: null,
      showCertificate: 1,
      showInquiry: 1,
      showForum: 1,
      
    }
  },
  computed: {
    ...mapState(['token', 'dark']),

    optionsAtivoInativo() {
      return [
        { text: this.$t('common.yes'), value: 1 },
        { text: this.$t('common.no'), value: 0 },
      ]
    },
    adminSelectMenuProps() {
      return this.dark
        ? { contentClass: 'weeduc-admin-select-menu-dark' }
        : {};
    },
  },
  methods: {
    async getDataWebsite() {
      try {
        const response = await apiWebsite.getWebsite(this.token)
        console.log(response)
        this.dataWebsite = response
        if (response) {
          this.showCertificate = response.showCertificate ?? 1
          this.showInquiry = response.showInquiry ?? 1
          this.showForum = response.showForum ?? 1
          this.image = typeof response.portalBannerFinalPath === 'string' ? response.portalBannerFinalPath : ''
          this.imagePreview = this.image ? this.image : null
        }
      } catch (error) {
        toast.error(this.$t('admin.siteConfig.portalLoadError'))
        console.error('Erro ao buscar dados do site:', error)
      }
    },
    updateFilePath(novoValor) {
      // Se for um arquivo, faz upload para AWS, senão apenas define o path
      if (novoValor && typeof novoValor === 'object' && novoValor instanceof File) {
        // Remove o preview anterior se existir
        if (this.imagePreview && typeof this.imagePreview === 'string' && this.imagePreview.startsWith('blob:')) {
          URL.revokeObjectURL(this.imagePreview)
        }
        this.imagePreview = URL.createObjectURL(novoValor)
        this.uploadImageAws(novoValor)
      } else {
        // Se for string (url), seta o preview para a url
        this.image = novoValor || ''
        this.imagePreview = this.image ? this.image : null
      }
    },
    async uploadImageAws(file) {
      try {
        const assinatura = await apiAWS.getSignatureImage(this.token, file.name)
        await this.putFileAws(assinatura.url, file)
        this.imageUpload = assinatura.token
        // Após upload, o preview já está setado pelo objeto local
      } catch (error) {
        this.notify(this.$t('admin.siteConfig.uploadImageError'), 'error')
      }
    },
    async putFileAws(url, file) {
      try {
        await apiAWS.putFileAWS(url, file)
      } catch (error) {
        this.notify(this.$t('admin.certificates.imageSaveError'), 'error')
      }
    },
    notify(mensagem, tipo = 'info') {
      // Aqui você pode integrar com um sistema de toast global, se desejar
      // Exemplo: this.$toast(mensagem, { type: tipo })
      // Por enquanto, apenas loga no console
      console.log(`[${tipo}] ${mensagem}`)
    },
    async salvarPortalAluno() {
      this.loading = true
      try {
        // Garante que portalBannerPath será string ou vazio, nunca objeto
        const payload = {
          ...this.dataWebsite,
          portalBannerPath: this.imageUpload,
          showCertificate: this.showCertificate,
          showInquiry: this.showInquiry,
          showForum: this.showForum,
        }
        const response = await apiWebsite.updateWebsite(
          this.token,
          this.dataWebsite.id,
          payload
        )
        this.notify(this.$t('admin.siteConfig.portalSaveSuccess'), 'success')
        console.debug(response)
      } catch (error) {
        this.notify(this.$t('admin.siteConfig.portalSaveError'), 'error')
        console.error('Erro ao atualizar o portalBannerPath:', error)
      } finally {
        this.loading = false
      }
    },
  },
  beforeUnmount() {
    if (this.imagePreview && typeof this.imagePreview === 'string' && this.imagePreview.startsWith('blob:')) {
      URL.revokeObjectURL(this.imagePreview)
    }
  },
  mounted() {
    this.getDataWebsite()
  },
}
</script>

<style scoped>
@import url('@/css/weeduc/admin/dashboard-weflix-shell.css');
@import url('./css/portalStudent.css');
</style>
